/******************************************************************************
 * Created Date: Tuesday Mar 29 2022                                          *
 * Author: Patrick B.                                                         *
 * -----                                                                      *
 * Last Modified: Tue Mar 29 2022                                             *
 * Modified By: Patrick B.                                                    *
 * -----                                                                      *
 * File: /src/components/algorithms/frames/LongTasksTypeSelect.js             *
 * Copyright (c) 2022 Kuva                                                    *
 ******************************************************************************/

import React from "react";
import {
  Select,
  FormControl,
  MenuItem,
  InputLabel,
  Typography
} from "@mui/material";
import PropTypes from "prop-types";

const LongTasksTypeSelect = ({ types, selectedType, setSelectedType }) => {
  const handleChange = event => {
    setSelectedType(event.target.value);
  };

  return (
    <FormControl
      variant="standard"
      style={{
        display: "flex",
        minWidth: "8ch",
        maxWidth: "20ch",
        margin: "0 15px 0 auto"
      }}
    >
      <InputLabel
        style={{
          fontSize: 14,
          width: "100%"
        }}
        id="job-type-label"
      >
        <Typography variant="subtitle1">Job Type</Typography>
      </InputLabel>
      <Select
        variant="standard"
        style={{ width: "100%" }}
        id="job-type"
        value={selectedType}
        label="job-type"
        onChange={handleChange}
      >
        {types.map(type => {
          return (
            <MenuItem key={type} value={type}>
              {type}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

LongTasksTypeSelect.propTypes = {
  types: PropTypes.array.isRequired,
  selectedType: PropTypes.string.isRequired,
  setSelectedType: PropTypes.func.isRequired
};

export default LongTasksTypeSelect;
